import request from "@form/utils/request";
import { Token } from "@form/types";

export const verifyBalance = async (data: {
  token: Token;
  user_address: string;
  amount: number;
}): Promise<boolean> => {
  return await request.rpc("wallet/verify_balance", data);
};
